<script setup lang="ts">

defineProps<{
  label?: string
  description?: string
  placement?: 'left' | 'right'
}>()
</script>

<template>
  <n-grid :x-gap="20" :y-gap="12" cols="1 450:3">
    <n-gi span="1 450:2">
      <header>
        <slot name="label">
          {{ label }}
        </slot>
      </header>
      <small v-if="description">
        {{ description }}
      </small>
    </n-gi>
    <n-gi class="flex items-center" :class="{ 'justify-start': placement === 'left', 'justify-end': placement === 'right' }">
      <slot />
    </n-gi>
  </n-grid>
</template>